var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactSettingsFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / User / Contact-settings-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-User-/-Contact-settings-fill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Settings-Fill",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,14 L12,22 L4,22 L4,22 C4,17.5817212 7.58172,14 12,14 L12,14 Z M12,13 C8.685,13 6,10.315 6,7 C6,3.685 8.685,1 12,1 C15.315,1 18,3.685 18,7 C18,10.315 15.315,13 12,13 Z M14.595,18.812 L14.5949999,18.8119995 C14.4682049,18.2784285 14.4682049,17.7225695 14.5950001,17.1889995 L13.6030001,16.6159995 L14.6030001,14.8839995 L15.5950001,15.4569995 L15.5950003,15.4569994 C15.9931623,15.0798804 16.4744613,14.8017204 17.0000003,14.6450004 L17.0000003,13.5000004 L19.0000003,13.5000004 L19.0000003,14.6450004 C19.5320003,14.8030004 20.0120003,15.0850004 20.4050003,15.4570004 L21.3970003,14.8840004 L22.3970003,16.6160004 L21.4050003,17.1890004 L21.4050003,17.1890008 C21.5316373,17.7222518 21.5316363,18.2777508 21.4050002,18.8110008 L22.3970003,19.3840008 L21.3970002,21.1160008 L20.4050002,20.5430008 L20.4050002,20.5430007 C20.0068372,20.9201207 19.5255392,21.1982797 19.0000002,21.3550007 L19.0000002,22.5000004 L17.0000002,22.5000004 L17.0000002,21.3550007 L17.0000002,21.3550007 C16.4744612,21.1982797 15.9931602,20.9201207 15.5950002,20.5430007 L14.6030001,21.1160007 L13.6030001,19.3840007 L14.5950002,18.8120007 L14.595,18.812 Z M18,17 L18,17 C17.447715,17 17,17.447715 17,18 C17,18.552285 17.447715,19 18,19 L18,19 C18.5522849,19 19,18.552285 19,18 C19,17.447715 18.5522849,17 18,17 L18,17 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSettingsFill);
export default __webpack_public_path__ + "static/media/Contact-settings-fill.458b2abfdd9c4845b675bae4dad20dc3.svg";
export { ForwardRef as ReactComponent };